const containerCls = "_rscy8ncje";
const mediaCls = "_rsm1o0px6m";

export { containerCls, mediaCls };
import "./richtext-media.style.linaria.module.css";
//# sourceMappingURL=richtext-media.style.js.map
